import ShopStatus from 'components/shop-status';
import useEditShopContext from 'contexts/shop.context';
import React from 'react';

const PreviewShopDetails = () => {
  const { shopDetails, setShopDetails } = useEditShopContext();

  const details = [
    { value: shopDetails.name, label: 'Shop Name' },
    { value: shopDetails.short_text, label: 'Shop Tagline' },
    { value: shopDetails.phone, label: 'Phone Number' },
    { value: shopDetails.email, label: 'Email Address' },
    { value: shopDetails.address.address_line, label: 'Shop Address' },
    { value: shopDetails.description, label: 'Shop Description' },
    { value: shopDetails.shopStatus, label: 'Shop Status' },
    { value: shopDetails.live, label: 'Live?' }
  ];
  return (
    <div className='space-y-6'>
      {details.map((detail) => (
        <div
          key={detail.label}
          className='border border-gray-1 rounded-md p-3.5 flex items-center mb-4'>
          <h2 className='text-sm   text-gray-5 max-w-[150px] w-full'>{detail.label}</h2>
          <p className='text-base text-gray-6 font-medium'>{detail.value}</p>
        </div>
      ))}

      <ShopStatus
        comment={shopDetails?.brandStatustext}
        setComment={(k: string) => setShopDetails({ ...shopDetails, brandStatustext: k })}
        className='my-6'
        selectedShopStatus={shopDetails.shopStatus}
        setSelectedShopStatus={(d) => setShopDetails({ ...shopDetails, shopStatus: d })}
        disabled
      />
    </div>
  );
};

export default PreviewShopDetails;
